export function parseUnitToNum(value: string): number {
    let parsedValue: number = Number(value.match(/[\d.]+/)?.[0]);
    if (value.includes('rem')) {
        parsedValue *= Number(getComputedStyle(document.body).fontSize.match(/[\d.]+/)?.[0]);
    }
    return parsedValue;
}